<template>
  <div class="home">
    <div class="TopBann">
      <!-- <topBarnav></topBarnav> -->
      <!-- 未登录状态显示 -->
      <div class="middle-Main" v-show="show1">
        <div class="it-main">
          <div class="item-txt">
            <span class="items-a">明商道</span>
            <span class="items-b">企业学习成长专属数字化平台</span>
            <span class="items-c">数字时代企业人才培育综合解决方案</span>
            <span class="items-d">美好的体验即将开始</span>
            <span class="items-e">{{ tent }}</span>
            <div class="items-nx nx">
              <el-input
                v-model.trim="phone"
                placeholder="输入手机号立即体验"
                class="items-in"
              >
                <el-button slot="append" @click="loginPage">免费使用</el-button>
              </el-input>
            </div>
          </div>
          <div class="items-image">
            <img src="../../assets/introduce/imagePe.png" class="" />
          </div>
        </div>
      </div>
      <!-- 登录后显示 -->
      <div class="middle-Main" v-show="show2">
        <div class="it-main">
          <div class="item-txt">
            <span class="item-d">美好的体验即将开始</span>
            <span class="items_e">{{ tent }}</span>
            <span class="item-f">创建属于您的企业的独立书院</span>
            <div class="items-nx">
              <el-input
                v-model.trim="CourName"
                placeholder="您的书院名称"
                class="items-in"
              >
                <el-button slot="append" @click="CreateUniv"
                  >免费使用</el-button
                >
              </el-input>
            </div>
            <span class="item-g">加入他人的企业书院</span>
            <div class="items-nx">
              <el-input
                v-model.trim="Invitecode"
                placeholder="请填写您的邀请码"
                class="items-in"
              >
                <el-button slot="append" @click="joinCollege"
                  >加入书院</el-button
                >
              </el-input>
            </div>
          </div>
          <div class="items-pic">
            <img src="../../assets/introduce/imagePeFal.png" class="" />
          </div>
        </div>
      </div>
    </div>
    <div class="module-two">
      <div class="container">
        <span class="title1">{{ text1 }}</span>
        <span class="title2">{{ text2 }}</span>
        <div class="md-a">
          <div v-for="(item, index) in data" :key="index" class="md-b">
            <div class="md-c">
              <img :src="item.imageUrl" />
            </div>
            <div class="md-c">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module-three">
      <div class="mt-a">
        <div class="mt-b">
          <img src="../../assets/introduce/img-bk.png" />
          <div class="mt-c">
            <div class="mt-d">
              <div><span class="mt mg">平台</span></div>
              <div>
                <span class="mt-e"
                  >涵盖多种应用场景，随时随地，想学就学；PC端、移动端、
                  小程序端，多终端一体化，稳定便捷。</span
                >
              </div>
            </div>
            <div class="mt-d ft">
              <div><span class="mt mg">内容</span></div>
              <div>
                <span class="mt-e"
                  >职业技能提升、经营管理创新、学历教育、职业证书培训，
                  海量内容实现全员分众开班，分类培养，分层实施。</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="mt-b">
          <div class="mt-f">
            <div class="mt-d">
              <div><span class="mt mg">定制</span></div>
              <div>
                <span class="mt-e"
                  >适时预约直播、线下师资授课、产教融合项目在线撮合
                  内容经验萃取专属服务、前沿课程定制开发。</span
                >
              </div>
            </div>
            <div class="mt-d ft">
              <div><span class="mt mg">运营</span></div>
              <div>
                <span class="mt-e"
                  >学习数据辅助人才的分析与考核评价，专属教务老师随时
                  在线等候服务，储备干部、核心人员导师制跟踪培养。</span
                >
              </div>
            </div>
          </div>
          <img src="../../assets/introduce/img-bl.png" class="imgTop" />
        </div>
      </div>
    </div>
    <div class="module-four">
      <div class="mt-a">
        <div class="cmp-a">
          <div class="ft-main">
            <div class="xx-left"></div>
            <span class="mf-a">优秀企业书院</span>
            <div class="xx-right"></div>
          </div>
        </div>
        <div class="mf-b">
          <div v-for="(item, index) in univData" :key="index" class="mf-d">
            <img :src="item.imageUrl" />
          </div>
        </div>
      </div>
    </div>
    <div class="module-five">
      <p class="mv-a">
        现在创建书院，体验企业专属的创新、开放、共享、共赢的学习平台，
      </p>
      <p class="mv-b">
        助力员工养成终身学习的习惯，不断提升职业能力，赋能企业创新发展。
      </p>
      <div class="mv-span">
        <span class="mv-c" @click="loginNew">立即体验</span>
      </div>
    </div>
    <foot></foot>
  </div>
</template>
<script>
import topBarnav from "../introducePage/component/navbar";
import foot from "@/views/introducePage/component/footer";
import { setCookie, getCookie } from "@/utils/cookies";
import { addorg, invitecode } from "@/api/Apis.js";
export default {
  metaInfo() {
    return {
      title:
        this.$route.meta.title +
        "-明商道_企业培训系统_企业培训解决方案服务商-中潮教育",
      meta: [
        {
          name: "keyWords",
          content:
            "明商道,融E学,企业培训,企业培训系统,企业培训管理系统,企业书院,企业大学"
        },
        {
          name: "description",
          content:
            "融E学·明商道-企业一站式线上线下培训平台，包含线上选课、线上培训、讲师预约、会议直播、在线考试、能力测评、员工学习数据管理等定制化的应用，帮助您解决企业培训中任何烦恼。创建企业书院,占领商道制高点。"
        }
      ]
    };
  },
  name: "home",
  components: {
    topBarnav,
    foot
  },
  data() {
    return {
      tent:
        "企业一站式线上线下培训平台，包含线上选课、线上培训、讲师预约、直播、考试、问卷等定制化的应用，帮助您解决企业培训中任何烦恼。",
      text1: "立足变革时代，整合产教资源，聚集企业需求，构建四位一体服务，",
      text2: "提供“书院式开放共享”学习平台，打造全员成长体系，赋能企业创新发展",
      data: [
        { imageUrl: require("../../assets/introduce/img-1.png"), name: "平台" },
        { imageUrl: require("../../assets/introduce/img-2.png"), name: "内容" },
        { imageUrl: require("../../assets/introduce/img-3.png"), name: "定制" },
        { imageUrl: require("../../assets/introduce/img-4.png"), name: "运营" }
      ],
      univData: [
        { imageUrl: require("../../assets/introduce/sy-1.png") },
        { imageUrl: require("../../assets/introduce/sy-2.png") },
        { imageUrl: require("../../assets/introduce/sy-3.png") },
        { imageUrl: require("../../assets/introduce/sy-4.png") },
        { imageUrl: require("../../assets/introduce/sy-5.png") },
        { imageUrl: require("../../assets/introduce/sy-6.png") },
        { imageUrl: require("../../assets/introduce/sy-7.png") },
        { imageUrl: require("../../assets/introduce/sy-8.png") },
        { imageUrl: require("../../assets/introduce/sy-9.png") }
      ],
      show1: true,
      show2: false,
      phone: "", //电话
      CourName: "", //学院名
      Invitecode: "" //邀请码
    };
  },
  mounted() {
    var token = getCookie("myToken");
    if (token == "" || token == null) {
      console.log("未登录");
    } else {
      this.show1 = false;
      this.show2 = true;
    }
  },
  methods: {
    //验证空格
    myTrim(str) {
      return str.replace(/(^\s*)|(\s*$)/g, "");
    },
    loginPage() {
      if (this.myTrim(this.phone) == "") {
        this.$message.warning("请输入手机号");
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        this.$message.warning("手机号格式不正确，请重新输入");
        return false;
      }
      setCookie("Inputphone", this.phone); //是否实名认证
      // window.location.href = "https://login-center-test.i-ronge.com/#/login"+"?redirectUrl="+window.location.href;
      setCookie("redirectUrl", window.location.href);
      const Url = window.location.host;
      if (Url === "organ-test.i-ronge.com") {
        //测试网址
        window.location.href = "https://login-center-test.i-ronge.com/#/login";
      } else if (Url === "localhost:8080") {
        // 本地跳转
        window.location.href = "https://login-center-test.i-ronge.com/#/login";
      } else if (Url === "organ.i-ronge.com") {
        // 默认正式
        window.location.href = "https://login-center.i-ronge.com/#/login";
      } else if (Url === "business.i-ronge.com") {
        // 默认正式
        window.location.href = "https://login-center.i-ronge.com/#/login";
      }
    },
    CreateUniv() {
      if (this.myTrim(this.CourName) == "") {
        this.$message.error("请输入您的书院名称");
        return false;
      }
      if (this.myTrim(this.CourName).length > 24) {
        this.$message.error("请输入您的书院名称");
        return false;
      }
      if (this.myTrim(this.CourName).length < 4) {
        this.$message.error("请输入您的书院名称");
        return false;
      }
      addorg({
        organizationName: this.CourName
      }).then(res => {
        if (res.msg == "success") {
          this.$router.push({
            path: "/college_Th",
            query: { name: this.CourName }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    //加入学院
    joinCollege() {
      if (this.myTrim(this.Invitecode) == "") {
        this.$message.error("请填写您的邀请码");
        return;
      }
      invitecode({
        inviteCode: this.Invitecode
      }).then(res => {
        if (res.msg == "success") {
          this.$message({
            message: res.msg,
            type: "success"
          });
          setTimeout(function() {
            window.location.reload();
          }, 1000);
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    loginNew() {
      setCookie("redirectUrl", window.location.href);
      const Url = window.location.host;
      if (Url === "organ-test.i-ronge.com") {
        //测试网址
        window.location.href = "https://login-center-test.i-ronge.com/#/login";
      } else if (Url === "localhost:8080") {
        // 本地跳转
        window.location.href = "https://login-center-test.i-ronge.com/#/login";
      } else if (Url === "organ.i-ronge.com") {
        // 默认正式
        window.location.href = "https://login-center.i-ronge.com/#/login";
      } else if (Url === "business.i-ronge.com") {
        // 默认正式
        window.location.href = "https://login-center.i-ronge.com/#/login";
      }
    }
  }
};
</script>
<style scoped>
.TopBann {
  width: 100%;
  height: 490px;
  background-image: url("../../assets/introduce/bg2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.middle-Main {
  display: flex;
  justify-content: center;
}
.it-main {
  width: 1200px;
  display: flex;
  justify-content: space-between;
}
.item-txt span {
  font-family: PingFang SC, PingFang SC-Bold;
  text-align: left;
  color: #ffffff;
  display: block;
}
.items-a {
  font-size: 48px;
  font-weight: 700;
  letter-spacing: 8px;
  margin-top: 70px;
}
.items-b {
  font-size: 24px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 1px;
  margin-top: 30px;
}
.items-c {
  font-size: 24px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 1px;
  margin-top: 10px;
}
.items-d {
  margin-top: 48px;
  font-size: 30px;
  font-weight: 700;
}
.items-e {
  width: 630px;
  font-weight: 400;
  font-size: 20px;
  margin-top: 10px;
  line-height: 30px;
}
.items_e {
  width: 530px;
  font-weight: 400;
  font-size: 20px;
  margin-top: 10px;
  line-height: 30px;
}
.item-d {
  margin-top: 70px;
  font-size: 30px;
  font-weight: 700;
}
.item-f {
  display: block;
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  margin-top: 40px;
  margin-bottom: 10px;
}
.item-g {
  display: block;
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  margin-top: 26px;
  margin-bottom: 10px;
}
.nx {
  margin-top: 24px;
}
.items-nx {
  display: flex;
  width: 386px;
  height: 55px;
}
.items-nx >>> .el-input__inner {
  height: 55px;
  border: 1px solid #fff;
}
.items-in {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Regular;
  background: #fff;
  border-radius: 7px;
}
.items-nx >>> .el-input-group__append,
.el-input-group__prepend {
  width: 135px;
  background: #e95467;
  color: #ffffff;
  text-align: center;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  border: 1px solid #e95467;
  border-radius: 7px;
}
.items-image img {
  margin-left: 30px;
  width: 500px;
  height: 500px;
}
.items-pic img {
  width: 530px;
  height: 280px;
  margin-top: 100px;
}
.module-two {
  width: 100%;
}
.title1 {
  display: block;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #4a4a4a;
  line-height: 38px;
  margin-top: 45px;
  text-align: center;
}
.title2 {
  display: block;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #4a4a4a;
  line-height: 38px;
  text-align: center;
}
.md-a {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.md-b {
  width: 251px;
  height: 278px;
  border-radius: 4px;
  background: #ffffff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
}
.md-c {
  display: flex;
  justify-content: center;
}
.md-c img {
  width: 207px;
  height: 137px;
  margin-top: 23px;
}
.md-c span {
  display: block;
  width: 151px;
  height: 48px;
  background: #1b6fd6;
  border-radius: 24px;
  text-align: center;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  line-height: 48px;
  color: #fff;
  margin-top: 48px;
}
.module-three {
  width: 100%;
  margin-top: 58px;
  display: flex;
  justify-content: center;
}
.mt-a {
  width: 1200px;
}
.mt-b {
  display: flex;
  justify-content: space-between;
}
.mt-b img {
  width: 436px;
  height: 405px;
}
.mt-c {
  margin-top: 130px;
}
.mt-d {
  display: flex;
  width: 697px;
  height: 80px;
  opacity: 1;
  background: #ecf3ff;
  border-radius: 38px;
}
.mt {
  display: inline-block;
  width: 137px;
  height: 60px;
  opacity: 1;
  background: #1f61d0;
  border-radius: 30px;
  text-align: center;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #ffffff;
  line-height: 60px;
}
.mg {
  margin: 10px 22px 10px 12px;
}
.mt-e {
  display: block;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #343434;
  line-height: 26px;
  margin-top: 15px;
  padding-right: 10px;
}
.ft {
  margin-top: 33px;
}
.mt-f {
  margin-top: 114px;
}
.module-four {
  width: 100%;
  margin-top: 67px;
  display: flex;
  justify-content: center;
}
.cmp-a {
  width: 100%;
  display: flex;
  justify-content: center;
}
.ft-main {
  width: 750px;
  display: flex;
  justify-content: space-between;
}
.xx-left {
  margin-top: 15px;
  width: 244px;
  height: 1px;
  border: 2px solid #1b6fd6;
}
.xx-right {
  margin-top: 15px;
  width: 244px;
  height: 1px;
  border: 2px solid #1b6fd6;
}
.mf-a {
  display: block;
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #1f61d0;
}
.mf-b {
  box-sizing: border-box;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
}
.mf-d {
  width: 380px;
  height: 171px;
  background: #ffffff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.mf-d img {
  width: 380px;
  height: 171px;
}
.module-five {
  width: 100%;
  height: 250px;
  margin-top: 60px;
  background-image: url("../../assets/introduce/Layer.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
.mv-a {
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #fffefe;
  line-height: 24px;
  padding-top: 44px;
}
.mv-b {
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #fffefe;
  line-height: 24px;
  padding-top: 15px;
}
.mv-span {
  display: flex;
  justify-content: center;
  margin-top: 43px;
}
.mv-c {
  display: block;
  width: 250px;
  height: 50px;
  opacity: 1;
  background: #ffffff;
  border-radius: 30px;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #1f61d0;
  line-height: 50px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/introducePage/home.vue